module.exports = __webpack_public_path__ + "img/kh4.694b197d.png";